import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// El HTML público puede llegar con SEO/favicon resueltos antes de iniciar React.
// No se borra esa metadata durante el bootstrap; LandingContext la sincroniza
// cuando existe una publicación efectiva del negocio.

document.addEventListener("DOMContentLoaded", () => {
  // Oculta y elimina cualquier banner
  const translateFrame = document.querySelector(".goog-te-banner-frame");
  if (translateFrame) {
    translateFrame.remove();
  }

  // Corrige márgenes dinámicos
  if (typeof MutationObserver === "function") {
    const observer = new MutationObserver(() => {
      const bodyStyle = getComputedStyle(document.body);
      if (bodyStyle.marginTop !== "0px") {
        document.body.style.marginTop = "0px";
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }
});

// Clientes que llegan por un enlace externo /checkout (sin #) no deben
// recibir la home ni un 404 de rutas SPA: normalizamos sólo rutas conocidas.
// Esto requiere además que el host sirva index.html para esas URLs (rewrite SPA).
const directRoute = window.location.pathname.replace(/\/+$/, "") || "/";
if (["/checkout", "/carrito", "/pedido/confirmado", "/productos"].includes(directRoute) || /^\/pago\/(success|failure|pending)$/.test(directRoute)) {
  if (!window.location.hash) {
    window.history.replaceState(null, "", `/#${directRoute}${window.location.search}`);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
